import { render, staticRenderFns } from "./main-visual.vue?vue&type=template&id=18380722&scoped=true&"
import script from "./main-visual.vue?vue&type=script&lang=js&"
export * from "./main-visual.vue?vue&type=script&lang=js&"
import style0 from "./main-visual.vue?vue&type=style&index=0&id=18380722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18380722",
  null
  
)

export default component.exports